export enum NewNoonReportTabs {
  Voyage = "1",
  FOMGOROB = "2",
  FOMGOCONS = "3",
  LOROBCons = "4",
  FW = "5",
  Speed = "6",
  Other = "7",
}
